import React, { useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import { Validation } from '../../general-ui/text-input/text';

interface SearchBarProps {
	label?: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
	placeholder: string;
	defaultValue?: string;
	style?: { [key: string]: any };
	numeric?: boolean;
	email?: boolean;
	disabled?: boolean;
	id?: string;
	password?: boolean;
	valid?: Validation;
	onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
	onSubmit?: () => void;
}

export default function SearchBar(props: SearchBarProps): JSX.Element {
	const {
		label,
		onChange,
		placeholder,
		defaultValue,
		style,
		numeric = false,
		email = false,
		disabled = false,
		password = false,
		id = '',
		valid = Validation.normal,
		onBlur,
		onKeyPress,
		onSubmit,
	} = props;

	const [entered, setEntered] = useState(false);
	const input = useRef<HTMLInputElement | null>(null);
	const [searchValue, setSearchValue] = useState('');

	function keyUp() {
		setEntered(!!input.current?.value);
	}

	function handleSearchValue(e: React.ChangeEvent<HTMLInputElement>) {
		setSearchValue(e.target.value);
		onChange(e);
	}

	useEffect(() => {
		if (defaultValue) {
			setEntered(true);
		}
	}, [defaultValue]);

	const type = useMemo(() => {
		if (numeric) {return 'number';}
		if (email) {return 'email';}
		if (password) {return 'password';}
		return 'text';
	}, [email, numeric, password]);

	return (
		<div
			className={classNames('field-group text small', { entered }, valid)}
			style={style}
		>
			{label && <label>{label}</label>}
			<div className="text-search-wrapper">
				<input
					className="text-search-input"
					onBlur={onBlur ? onBlur : () => null}
					id={id}
					disabled={disabled}
					ref={input}
					type={type}
					placeholder={placeholder}
					onChange={handleSearchValue}
					onKeyUp={keyUp}
					onKeyPress={onKeyPress}
					defaultValue={defaultValue ?? ''}
				/>
				<button
					disabled={searchValue === ''}
					className="text-search-button"
					onClick={onSubmit}
				>
					<Icon name={ICONS.SEARCH} size={18} color={COLORS.WHITE} />
				</button>
			</div>
		</div>
	);
}
